// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"clicks-per-day_cardHeader_3oq8x","cardDropdown":"clicks-per-day_cardDropdown_1pgiI","clicksPerDayNoData":"clicks-per-day_clicksPerDayNoData_2M1JB"};